import React, { useState } from "react";
import { useStaticQuery, graphql, Script } from "gatsby";
import { Helmet } from "react-helmet";
// import metaImage from "../../common/images/meta/metaimage.jpeg"
import Seo from "../main/Seo";
import Header from "../main/Header/header";
import Footer from "../main/Footer/footer";
import "../../common/css/bootstrap.min.css";

const Layout = ({
  title,
  description,
  image,
  isHomePage,
  currentPage,
  children,
  lang,
  translations,
  isAboveRefPoint,
  translateURL,
  langURL,
  pageUrl,
  pageId
}) => {
  const layoutData = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `);
  const [loaded, setLoaded] = useState(false);
  // const [loadedDefault, setLoadedDefault] = useState(false);
  // const [loadedSlider, setLoadedSlider] = useState(false);
  console.log(translations,"need to know translations data");
  console.log(translateURL,"need to know translateURL data");
  console.log(langURL,"need to know langURL data");
  console.log(currentPage,"need to know currentPage data");
  return (
    <div>
      <Helmet>
      
     
      <script data-react-helmet="true" async src={`https://www.googletagmanager.com/gtag/js?id=G-Q0DSR88QBY`}></script>

<script data-react-helmet="true">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-Q0DSR88QBY');
        `}
</script>


{lang === "ar" ? 

<script type="application/ld+json">
{`
{
  "@context": "https://schema.org/",
  "@type": "WebSite",
  "name": "Jameel Motors",
  "url": "https://jameelmotors.com/ar/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://jameelmotors.com/ar/?#={search_term_string}",
    "query-input": "required name=search_term_string"
  }
  }
  `}
</script>

: lang === "zh_CN" ?  <script type="application/ld+json">
{`
{
  "@context": "https://schema.org/",
  "@type": "WebSite",
  "name": "Jameel Motors",
  "url": "https://jameelmotors.com/zh-hans/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://jameelmotors.com/zh-hans/?#={search_term_string}",
    "query-input": "required name=search_term_string"
  }
  }
  `}
</script>
:
<script type="application/ld+json">
{`
{
  "@context": "https://schema.org/",
  "@type": "WebSite",
  "name": "Jameel Motors",
  "url": "https://jameelmotors.com/en/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://jameelmotors.com/en/?#={search_term_string}",
    "query-input": "required name=search_term_string"
  }
  }
  `}
</script>
}

{/* <script type="application/ld+json">
{`
  "@context": "https://schema.org/",
  "@type": "WebSite",
  "name": "Jameel Motors",
  "url": "https://jameelmotors.com/en/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://jameelmotors.com/en/?#={search_term_string}",
    "query-input": "required name=search_term_string"
  }
  `}
</script> */}

        {lang === "ar" ? (
          <body className="arabic" />
        ) : (
          <body className="english" />
        )}
        {/* <link
          href={require("../../common/css/bootstrap.min.css")}
          rel="preload"
          as="style"
        /> */}

<link rel="icon" href="../../common/images/meta/favicon.ico" type="image/x-icon"/>
{console.log(currentPage,"currentPage data to be here")}

{/* <link rel="alternate" hreflang="x-default" href={ "https://jameelmotors.com/en" + currentPage.localizedWpmlUrl}/> */}
<link rel="alternate" href={lang=="en" || lang=="en_US" ? "https://jameelmotors.com" + langURL : "https://jameelmotors.com" + translateURL} hreflang="x-default" />
<link rel="alternate" hreflang={pageId == "zh_CN" ? "zh-hans" : pageId == "ar" ? "ar" : "en" } href={
  "https://jameelmotors.com" + 
  (pageUrl && pageUrl.includes('home')  // Check if pageUrl is defined
    ? (pageId === "ar" 
        ? "/ar/" 
        : pageId === "zh_CN" 
        ? "/zh-hans/" 
        : "/en/") 
    : pageUrl || "")  // If pageUrl is not defined, fallback to an empty string
} />

 {translations && translations.map((data => {
  {console.log(data.locale.id,"test data")}
  if (data.publishStatus.status !== 'private') {
    console.log(data.localizedWpmlUrl,"data.localizedWpmlUrl")
        return(
        <link rel="alternate" hreflang={data.locale.id == "zh_CN" ? "zh-hans" : data.locale.id == "ar" ? "ar" : "en" } href={
          "https://jameelmotors.com" + 
          (data.localizedWpmlUrl.includes('home') 
            ? (data.locale.id === "ar" 
                ? "/ar/" 
                : data.locale.id === "zh_CN" 
                ? "/zh-hans/" 
                : "/en/") 
            : data.localizedWpmlUrl)
        } />
    );
  }
}))} 

{/* 
<link rel="alternate" hreflang="en" href={lang=="en" || lang=="en_US" ? "https://jameelmotors.com" + langURL : "https://jameelmotors.com" + translateURL} />
  {lang=="en" || translateURL == null ? " ": <link rel="alternate" hreflang="ar" href={lang=="ar" ? "https://jameelmotors.com" + langURL :"https://jameelmotors.com" + translateURL } />} */}
      </Helmet>
    <Script src="/js/main.js" onLoad={() => setLoaded(true)} />
      <Script
        src="https://www.google.com/recaptcha/api.js"
        async
        defer
      ></Script>
    {/* {loaded && <Script src="/js/bootstrap.js"/>} */}
      {/* {loaded && <Script src="/js/default.js"  />} */}

      {loaded && <Script src="/maps/countries.js"/>}
      {loaded && <Script src="/maps/miniature.earth.js"/>}
      {loaded && <Script src="/maps/miniature.earth.textimage.js"/>}
      {loaded && <Script src="/maps/custom.js"/>}


      <Seo
        title={title ? title : "Jameel Motors"}
        description={
          description ? description : "Jameel Motors" 
        }
        image={image ? image : "https://media.jameelmotors.com/wp-content/uploads/2023/12/metaimage.jpeg"}
      />
      <Header lang={lang} translations={translations} isAboveRefPoint={isAboveRefPoint} />
      <div className="mainWrapper">
        <main style={{ minHeight: 500 }}>{children}</main>
      </div>
      <Footer lang={lang} />
    </div>
  );
};

export default Layout;


